import React from 'react';
import { connect } from 'react-redux';
import { Suggestions } from '../../../client/redux/search/types';
import StateInterface from '../../../client/redux/types';
import { LandingPageRedirectOptions } from '../../../client/components/Search/searchService';
import SearchContent from './SearchContent';

export interface SearchProps {
    suggestion: Suggestions;
    searchRedirect: Suggestions;
    landingRedirects: LandingPageRedirectOptions;
}

const Search: React.SFC<SearchProps> = ({ searchRedirect, landingRedirects, suggestion }) => {
    return (
        <SearchContent suggestion={suggestion} landingRedirects={landingRedirects} searchRedirect={searchRedirect} />
    );
};

const mapStateToProps = (state: StateInterface) => {
    const { landingRedirects } = state.redirect;
    const { searchRedirect, suggestion, query } = state.searchSuggestion;
    return { searchRedirect, landingRedirects, suggestion, query };
};

export default connect(mapStateToProps)(Search);
